/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: var(--gradient-background);
  color: white;

  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;
`;
